import React, { useRef, useState } from 'react';
import gsap from 'gsap';
import { Flip } from 'gsap/Flip';
import { useGSAP } from '@gsap/react';
import './style/FlipLayout.css';

// تسجيل الـ Flip Plugin
gsap.registerPlugin(Flip);

const mockServices = [
    { id: 1, title: "Full-Stack Development", desc: "بناء تطبيقات ويب مخصصة وسريعة باستخدام قوة Django وهندسة الـ React المتطورة." },
    { id: 2, title: "E-Commerce Growth", desc: "تحسين وتطوير المتاجر الإلكترونية لرفع معدلات التحويل وزيادة الأرباح بشكل حقيقي." },
    { id: 3, title: "Technical SEO & Speed", desc: "تهيئة المنصات الرقمية لتصدر محركات البحث العالمية بـ Core Web Vitals ممتازة." },
    { id: 4, title: "Code Maintenance", desc: "صيانة و تطوير البرمجيات المختلفه و التعديل عليها لتناسب حاجة عملائنا" },
    { id: 5, title: "Front-End Development", desc: "تطوير و هندسة واجهات المستخدم الأنيقه و الجذابه لتزيد من إقبال العملاء علي تطبيقاتكم معنا" },
    { id: 6, title: "UI & UX Design", desc: "تصميم مخطط توضيحى لشكل واجهى المستخدم و البحث في افضل التصميمات بين الأناقه و الشياكه" },
];

const FlipServices = () => {
    const containerRef = useRef(null);
    const [activeCard, setActiveCard] = useState(null);
    const flipStateRef = useRef(null);

    // 1. التقاط الحالة الحالية (First) يدوياً عند الضغط وقبل تغيير الـ State
    const handleCardClick = (id) => {
        if (activeCard === id) return; // الكارت متمدد بالفعل
        document.querySelector(`.card-desc-${id}`).style.display="inline-block";
        // أخذ لقطة لجميع عناصر الكروت قبل تغيير الـ Layout
        flipStateRef.current = Flip.getState(".service-card, .card-title, .card-desc");
        setActiveCard(id);
    };

    const handleClose = (e) => {
        e.stopPropagation(); // منع حدوث Click على الكارت الأب
        flipStateRef.current = Flip.getState(".service-card, .card-title, .card-desc");
        e.target.parentElement.children[0].children[1].style.display="none";
        setActiveCard(null);
    };

    // 2. تفعيل الحركات (Play) فور رصد تغيير الـ State وتحديث الـ DOM
    useGSAP(() => {
        if (!flipStateRef.current) return;
        Flip.from(flipStateRef.current, {
            duration: 0.7,
            ease: "power3.out",
            absolute: true, // يمنع تدمير الـ Layout أثناء حركة العناصر الأخرى المحيطة
            scale: true,    // يضمن سلاسة تحول أحجام النصوص والـ Divs الداخلية
            stagger: 0.02,  // تداخل زمني بسيط يعطي مرونة بصرية مذهلة
        });
    }, { scope: containerRef, dependencies: [activeCard] });

    return (
        <div id="services" ref={containerRef} className="flip-section">
            <h2 className="flip-title">خدماتنا الهندسية</h2>
            
            <div className="services-grid">
                {mockServices.map((service) => {
                    const isExpanded = activeCard === service.id;
                    return (
                        <div
                            key={service.id}
                            className={`service-card ${isExpanded ? 'expanded' : ''}`}
                            onClick={() => handleCardClick(service.id)}
                            // الـ data-flip-id مهمة جداً لـ GSAP ليعرف أي عنصر يطابق الآخر
                            data-flip-id={`card-${service.id}`}
                        >
                            <div>
                                <h3 className="card-title" data-flip-id={`title-${service.id}`}>
                                    {service.title}
                                </h3>
                                <p className={`card-desc card-desc-${service.id}`} data-flip-id={`desc-${service.id}`}>
                                    {service.desc}
                                </p>
                            </div>
                            
                            {isExpanded && (
                                <button className="close-btn" onClick={handleClose}>
                                    إغلاق التفاصيل ×
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FlipServices;